import { render, staticRenderFns } from "./ConferenceDiagnosisComp.vue?vue&type=template&id=38749016&scoped=true"
import script from "./ConferenceDiagnosisComp.vue?vue&type=script&lang=js"
export * from "./ConferenceDiagnosisComp.vue?vue&type=script&lang=js"
import style0 from "./ConferenceDiagnosisComp.vue?vue&type=style&index=0&id=38749016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38749016",
  null
  
)

/* custom blocks */
import block0 from "./ConferenceDiagnosisComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports